module.exports = __webpack_public_path__ + "static/saastory-og-cover-890eeb5277d8ff72d481caaad6ede07f.png";